module.exports = __webpack_public_path__ + "img/flipnumber.383d6664.gif";